/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

window.$ = window.jQuery = require("jquery");

require("youtube-background");
require("waypoints/lib/jquery.waypoints.js");
require("waypoints/lib/shortcuts/sticky.js");
require("dragon-lightbox/dist/dragon-lightbox.min.js");
require("is-in-viewport");

import "bootstrap";
import "gasparesganga-jquery-loading-overlay";
import "slick-carousel";

import Plyr from "plyr";
import lightbox from "lightbox2";
import svg4everybody from "svg4everybody";

import AjaxHandler from "./modules/ajax-handler.js";
import BackgroundVideo from "./modules/background-video.js";
import MegaMenuImages from "./modules/mega-menu-images.js";
import MobileStepMenu from "./modules/step-menu.js";
import FloatingSearch from "./modules/floating-search.js";
import PostsPagination from "./modules/posts-pagination.js";
import ProductCategoryFilter from "./modules/product-category-filter.js";
import ProductArchiveTabs from "./modules/product-archive-tabs.js";
import ResistanceTable from "./modules/resistance-table.js";
import ClampingDistance from "./modules/clamping-distance.js";
import PressureTemperatureTool from "./modules/pressure-temperature-tool.js";
import "./modules/dimension-tool.js";
import Woocommerce from "./woocommerce.js";
import Calculators from "./modules/calculators.js";

const Ajax = new AjaxHandler();


new MegaMenuImages();
new MobileStepMenu();
new BackgroundVideo();
new FloatingSearch();
new ProductCategoryFilter();
new ProductArchiveTabs();
new ResistanceTable();
new Calculators();
new Woocommerce();
new ClampingDistance();
new PressureTemperatureTool();

const pagination = new PostsPagination();
pagination.initPagination();

let teamsFilter = document.getElementById("teams-filter");
let documentsFilter = document.getElementById("documents-filter");
let footerMiddle = document.getElementsByClassName("footer-middle");
let departmentFilter = document.getElementById("teams-filter");
let breadcrumbs = document.getElementById("site-breadcrumbs");

const elementsExists = element => {
    if ("undefined" != typeof element && null != element) {
        return true;
    }
    return false;
};

svg4everybody({});

lightbox.option({
    showImageNumberLabel: false
});

// Video player
$("[data-plyr-embed-id]").each(function (e) {
    var $this = $(this);

    $this
        .parent()
        .find("iframe")
        .remove();

    const player = new Plyr($this, {
        hideControls: false,
        captions: {
            active: true
        }
    });

    player.toggleControls(false);

    player.on("play", event => {
        player.toggleControls(true);
    });

    window.player = player;
});

$("[data-youtube]").youtube_background({
    "fit-box": true
});

// Breadcrumbs Mobile
if (elementsExists(breadcrumbs)) {
    $(window)
        .on("resize", function () {
            var w = document.documentElement.clientWidth;
            let $elem = $("#site-breadcrumbs");

            if (w <= 600) {
                if ($elem.prev().hasClass("module-hero"))
                    $("#site-breadcrumbs").insertBefore($elem.prev());
            } else {
                if ($elem.next().hasClass("module-hero"))
                    $("#site-breadcrumbs").insertAfter($elem.next());
            }
        })
        .resize();
}

// Footer Accordion
if (elementsExists(footerMiddle)) {
    let accordions = document.querySelectorAll(
        ".footer-middle .footer-title, .site-footer-links > li > a"
    );

    for (let accordion of accordions) {
        accordion.addEventListener("click", e => {
            e.preventDefault();
            e.currentTarget.classList.toggle("open");
            var panel = e.currentTarget.nextElementSibling;

            panel.classList.toggle("expand");

            if (panel.classList.contains("expand")) {
                panel.classList.toggle("in");
            } else {
                panel.classList.toggle("in");
            }
        });
    }
}

// Filtering for teams
if (elementsExists(teamsFilter)) {
    tabsFilter(teamsFilter, true);
}

// Filtering for documents
if (elementsExists(documentsFilter)) {
    var param = window.location.hash.substr(1);

    if (param) {
        let link = document.querySelector(
            '.nav-link[href="#' +
            param +
            '"], .list-item[href="#' +
            param +
            '"]'
        );

        if (link) {
            if (link.classList.contains("nav-link")) {
                link.click();
            } else {
                let parts = param.split("_");
                let parent = document.querySelector(
                    '[href="#' + parts[0] + "-" + parts[1] + '"]'
                );

                if (parent) {
                    parent.click();
                    link.click();
                }
            }
        }
    }

    let links = documentsFilter.querySelectorAll(".list-item, .nav-link");

    links.forEach(el => {
        el.addEventListener("click", e => {
            let link = e.target;
            window.location.hash = link.getAttribute("href");
        });
    });
}

// Filtering for departments
if (elementsExists(departmentFilter)) {
    let param = window.location.hash.substr(1);

    departmentHash(param);

    departmentFiltering(departmentFilter);

    document.addEventListener("DOMNodeInserted", () => {
        departmentFiltering(departmentFilter);
    });

    $(document).on("click", ".list-item-subitem", function () {
        let full_param = $(this)
            .attr("href")
            .replace("#", "");
        $(".list-item-subitem.active").removeClass("active");
        $(this).addClass("active");

        $(".department-parent").addClass("d-none");
        $('.department-parent[id="' + full_param + '"]').removeClass("d-none");

        $(".filter-results h3").remove();
    });
}

const maybeClickSubLink = () => {
    let param = window.location.hash.substr(1);
    let full_param = window.location.hash.substr(1);

    if (!param && param.includes("_")) {
        return false;
    }

    waitForElm('.list-item-subitem[href="#' + full_param + '"]').then(elm => {
        if (!elm) return;

        $(".list-item-subitem.active").removeClass("active");
        $(elm)
            .trigger("click")
            .addClass("active");

        $(".department-parent").addClass("d-none");

        $('.department-parent[id="' + full_param + '"]').removeClass("d-none");
    });
};

function departmentHash(param) {
    let full_param = window.location.hash.substr(1);
    let link;
    let type = "first";
    let second_param = "";

    if (param) {
        if (param.includes("_")) {
            param = param.split("_")[0];
            type = "second";
        }

        link = document.querySelector(
            '.list-item[href="#' +
            param +
            '"], .list-item[href="#' +
            param +
            '"]'
        );

        console.log(link);

        console.log('trying to find link with param "' + param + '"');
        console.log(full_param);

        if (link) {
            link.click();
        }

        // scroll web down to class
        $("html, body").animate(
            {
                scrollTop: $(".tab-content").offset().top
            },
            1000
        );
    } else {
        $(".block-team .team-grid").css("visibility", "visible");
        $(".tab-content .department-title").css("visibility", "visible");
    }
}

function departmentFiltering(departmentFilter) {
    let links = departmentFilter.querySelectorAll(".list-item");

    links.forEach(el => {
        el.addEventListener("click", e => {
            let link = e.target;
            window.location.hash = link.getAttribute("href");
        });
    });
}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// Dynamic tab filtering
function tabsFilter(where, firstRun = false) {
    const inputClasses = ".nav-link, .list-item, input";

    let all_inputs = [...where.querySelectorAll(inputClasses)];

    all_inputs.forEach(el => {
        // Only run click action for tabs once
        if (!firstRun && el.classList.contains("nav-link")) return;

        el.addEventListener("click", e => {
            let link = e.target;
            let data = "";

            if (link.classList.contains("list-item")) {
                e.preventDefault();

                where
                    .querySelectorAll(".list-item")
                    .forEach(obj => obj.classList.remove("selected"));
                link.classList.add("selected");

                let reducedInputs = [
                    ...link
                        .closest(".tab-content")
                        .querySelectorAll(inputClasses)
                ];

                data = reducedInputs.reduce((acc, a) => {
                    // Return active filter values from non-inputs
                    if (a.dataset.type) {
                        if (a.classList.contains("selected"))
                            return {
                                ...acc,
                                [a.dataset.type]: a.dataset.value
                            };
                        else return acc;
                    } else {
                        return { ...acc, [a.name]: a.value };
                    }
                }, []);
            } else if (link.classList.contains("nav-link")) {
                where
                    .querySelectorAll(".nav-link")
                    .forEach(obj => obj.classList.remove("selected"));
                link.classList.add("selected");
            }

            let country_id =
                where.querySelector("input[name=country]").value ?? 0;

            let country_code =
                where.querySelector("input[name=country_code]").value ?? 0;

            let postData = {};
            let tab = "";
            let tabContent = "#teams-filter .team-grid";

            if (where == teamsFilter) {
                data = {
                    ...data,
                    country: country_id,
                    country_code: country_code
                };

                postData = {
                    data: data,
                    tab_type: "team",
                    post_type: "team"
                };

                tab = `.tab-pane#country-${country_id}`;
            }

            console.log("before request");

            Ajax.postRequest(postData, "filter_tabs", tabContent).then(
                response => {
                    if (response) {
                        document.querySelector(tab).innerHTML =
                            response.data.html;
                        tabsFilter(where);
                    } else {
                        console.log("Error.");
                    }

                    $(tabContent).css("visibility", "visible");
                    $(".tab-content .department-title").css(
                        "visibility",
                        "visible"
                    );

                    maybeClickSubLink();
                }
            );
        });
    });
}

// Run on scroll
const ProductTableScroll = {
    init: function () {
        console.log("Run init");

        this.mHeader = document.getElementById("main-header");
        this.mProductTable = document.getElementById("products-table");

        if (!this.mProductTable) return;

        this.mTableHeader = this.mProductTable.querySelector("thead > tr");

        $(window).on("scroll", () => {
            let self = ProductTableScroll;
            self.doElsCollide(self.mHeader, self.mProductTable);
        });
    },

    getThWidths: () => {
        let ths = ProductTableScroll.mTableHeader.querySelectorAll("th");
        return Array.from(ths, th => th.offsetWidth);
    },

    toggleFixedHeader: function (collide) {
        let thWidths = this.getThWidths();

        if (!this.isMobile()) {
            this.mTableHeader.querySelectorAll("th").forEach((th, i) => {
                th.style.width = thWidths[i] + "px";
            });

            this.mTableHeader.style.top = collide
                ? this.mHeader.offsetHeight + "px"
                : 0;
            collide
                ? this.mTableHeader.classList.add("product-table-header-fixed")
                : this.mTableHeader.classList.remove(
                    "product-table-header-fixed"
                );
        } else {
            this.mTableHeader.style.top = 0;
            this.mTableHeader.classList.remove("product-table-header-fixed");
        }
    },

    isMobile: function () {
        return window.innerWidth < 768;
    },

    doElsCollide: function (el1, el2) {
        el1.offsetBottom = el1.offsetTop + el1.offsetHeight;
        el2.offsetBottom = el2.offsetTop + el2.offsetHeight;

        // Get scroll position
        var scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

        // Calculate the distance from the top of the page to the element
        let distanceToTop = el2.offsetTop;
        let parent = el2.offsetParent;

        while (parent !== null) {
            distanceToTop += parent.offsetTop;
            parent = parent.offsetParent;
        }

        let collide = distanceToTop < scrollTop + this.mHeader.offsetHeight;

        this.toggleFixedHeader(collide);
    }
};

ProductTableScroll.init();

// Sync transform-origin with focal point for .cover-zoom Cover blocks
document.querySelectorAll('.cover-zoom .wp-block-cover__image-background').forEach(function(img) {
    var pos = img.dataset.objectPosition || img.style.objectPosition || '50% 50%';
    img.style.transformOrigin = pos;
});
